import { render, staticRenderFns } from "./TradeRequestFinalizeForm.vue?vue&type=template&id=3bda4baa"
import script from "./TradeRequestFinalizeForm.vue?vue&type=script&lang=js"
export * from "./TradeRequestFinalizeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports